import React from 'react'

function ImportStockPage(): JSX.Element {
  return (
    <div className="import-stock-page tw-flex-1 tw-p-8 tw-overflow-y-auto">
      <div className="tw-max-w-4xl tw-mx-auto">
        {/* Back button and breadcrumb navigation */}
        <div className="tw-mb-6">
          <div className="tw-flex tw-items-center tw-text-sm tw-text-slate-500 tw-mb-2">
            <a className="tw-flex tw-items-center hover:tw-text-primary" href="#">
              <span className="material-icons-outlined tw-text-lg tw-mr-1">arrow_back</span>
              Back to Stock Management
            </a>
          </div>
          <div className="tw-text-sm tw-text-slate-500 tw-mb-2">
            <span>Product</span>
            <span className="tw-mx-2">›</span>
            <span>Stock Management</span>
            <span className="tw-mx-2">›</span>
            <span className="tw-text-slate-700 tw-font-medium">Import Stock</span>
          </div>
          <h1 className="tw-text-3xl tw-font-bold tw-text-slate-800">Import Stock</h1>
        </div>

        {/* Progress tracker - 4 step indicator */}
        <div className="tw-flex tw-items-center tw-justify-center tw-mb-12">
          <div className="tw-flex tw-items-center">
            <div className="tw-flex tw-flex-col tw-items-center">
              <div className="tw-w-10 tw-h-10 tw-rounded-full tw-bg-primary tw-text-white tw-flex tw-items-center tw-justify-center tw-font-bold">1</div>
              <div className="tw-text-sm tw-font-semibold tw-text-primary tw-mt-2">Upload File</div>
            </div>
          </div>
          <div className="tw-flex-1 tw-h-0.5 tw-bg-slate-200 tw-mx-4"></div>
          <div className="tw-flex tw-items-center">
            <div className="tw-flex tw-flex-col tw-items-center">
              <div className="tw-w-10 tw-h-10 tw-rounded-full tw-bg-slate-200 tw-text-slate-500 tw-flex tw-items-center tw-justify-center tw-font-bold">2</div>
              <div className="tw-text-sm tw-text-slate-500 tw-mt-2">Map Columns</div>
            </div>
          </div>
          <div className="tw-flex-1 tw-h-0.5 tw-bg-slate-200 tw-mx-4"></div>
          <div className="tw-flex tw-items-center">
            <div className="tw-flex tw-flex-col tw-items-center">
              <div className="tw-w-10 tw-h-10 tw-rounded-full tw-bg-slate-200 tw-text-slate-500 tw-flex tw-items-center tw-justify-center tw-font-bold">3</div>
              <div className="tw-text-sm tw-text-slate-500 tw-mt-2">Review</div>
            </div>
          </div>
          <div className="tw-flex-1 tw-h-0.5 tw-bg-slate-200 tw-mx-4"></div>
          <div className="tw-flex tw-items-center">
            <div className="tw-flex tw-flex-col tw-items-center">
              <div className="tw-w-10 tw-h-10 tw-rounded-full tw-bg-slate-200 tw-text-slate-500 tw-flex tw-items-center tw-justify-center tw-font-bold">4</div>
              <div className="tw-text-sm tw-text-slate-500 tw-mt-2">Complete</div>
            </div>
          </div>
        </div>

        {/* Main content card with file upload */}
        <div className="tw-bg-white tw-rounded-lg tw-p-8">
          <h2 className="tw-text-xl tw-font-semibold tw-text-slate-800 tw-mb-6">Upload Stock File</h2>
          
          {/* Upload area */}
          <div className="tw-border-2 tw-border-dashed tw-border-slate-300 tw-rounded-lg tw-p-12 tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center">
            <span className="material-icons-outlined tw-text-5xl tw-text-slate-400 tw-mb-4">description</span>
            <button className="tw-text-primary tw-font-semibold tw-mb-2">Click to upload</button>
            <p className="tw-text-sm tw-text-slate-500">CSV, XLS, or XLSX files supported</p>
          </div>

          {/* File requirements section */}
          <div className="tw-mt-8 tw-bg-blue-50 tw-p-6 tw-rounded-lg">
            <h3 className="tw-font-semibold tw-text-slate-800 tw-mb-4">File Requirements:</h3>
            <ul className="tw-list-disc tw-list-inside tw-space-y-2 tw-text-sm tw-text-slate-600">
              <li>File must contain columns for Product SKU, Warehouse, and Quantity</li>
              <li>First row should contain column headers</li>
              <li>Quantity values should be numeric</li>
              <li>Warehouse names must match exactly: Jakarta, Surabaya, or Bandung</li>
              <li>Imported data will replace existing stock quantities</li>
              <li>SHOULD USE ACTIVE PRODUCT</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImportStockPage